/** The storages Google's Consent Mode gates, all following one answer. */
const CONSENT_MODE_STORAGES = [
  "ad_storage",
  "analytics_storage",
  "ad_user_data",
  "ad_personalization",
] as const;

/** Google's Consent Mode settings for a visitor who did or didn't consent. */
export function consentModeSettings(granted: boolean) {
  const state = granted ? "granted" : "denied";
  return Object.fromEntries(
    CONSENT_MODE_STORAGES.map((storage) => [storage, state])
  ) as Record<(typeof CONSENT_MODE_STORAGES)[number], "granted" | "denied">;
}

/**
 * An inline script that denies every storage before Google's tags load; the
 * pages runtime grants them once the visitor accepts the banner.
 */
export function consentModeDefaultScript() {
  const settings = JSON.stringify({
    ...consentModeSettings(false),
    wait_for_update: 500,
  });
  return (
    `<script>window.dataLayer=window.dataLayer||[];` +
    `function gtag(){dataLayer.push(arguments);}` +
    `gtag('consent','default',${settings});</script>`
  );
}
